import React from 'react';
import { Link } from 'react-router-dom';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { PATHS } from 'src/constants/paths';
import { getLocationGroupCountText } from 'src/features/assemblies/bulkReplaceReviewPage/modules/bulkReplaceReviewTableRow/BulkReplaceReviewTableRow.helper';
import { useGetDefaultAssemblies } from 'src/hooks';
import { IAssembly } from 'src/interfaces';

import {
  chooseTag,
  columns,
} from '../bulkReplaceSummaryPage/BulkReplaceSummaryPage.helper';
import { SUMMARY_PAGE_COLUMN } from '../bulkReplaceSummaryPage/BulkReplaceSummaryPage.interface';
import {
  Chip,
  CustomTableCell,
  LinkContainer,
  TableRowContainer,
} from '../bulkReplaceSummaryPage/BulkReplaceSummaryPage.styled';

const RowHeader = ({
  assemblyName,
  assemblyId,
}: {
  assemblyName: string;
  assemblyId: number;
}) => {
  return (
    <CustomTooltip
      width={500}
      placement="right"
      title={assemblyName}
      overflowWidth={334}
      renderChildren={(ref, style) => (
        <LinkContainer variant="text">
          <Link
            to={`${PATHS.ASSEMBLY_DETAILS(assemblyId)}`}
            target="_blank"
            ref={ref}
            style={style}>
            {assemblyName}
          </Link>
        </LinkContainer>
      )}
    />
  );
};

export const BulkReplaceSummaryTableRow = (props: {
  assembly: IAssembly | any;
  isChildRow?: boolean;
  isInherited?: boolean;
}) => {
  const { isChildRow, assembly } = props;

  const { id, name, layout } = assembly;

  const { data: defaultAssemblies = [] } = useGetDefaultAssemblies(
    [`assembly_id.list=${id}`],
    !id,
    'timing',
  );

  const locationGroupCountText = getLocationGroupCountText(
    defaultAssemblies,
    id,
  );

  return (
    <TableRowContainer isChildRow={isChildRow}>
      {columns.map((column, key) => (
        <CustomTableCell
          key={key}
          align={SUMMARY_PAGE_COLUMN.TAGS === column.key ? 'right' : 'left'}
          width={column.width}>
          {(() => {
            switch (column.key) {
              case SUMMARY_PAGE_COLUMN.ASSEMBLY_NAME:
                return <RowHeader assemblyId={id} assemblyName={name} />;
              case SUMMARY_PAGE_COLUMN.CHANNEL_TYPE:
                return <>{layout?.layoutType?.name}</>;
              case SUMMARY_PAGE_COLUMN.NO_OF_LOCATION_GROUPS:
                return <>{locationGroupCountText}</>;
              case SUMMARY_PAGE_COLUMN.STATE:
                return <></>;
              case SUMMARY_PAGE_COLUMN.TAGS:
                return (
                  <Chip
                    enabled={true}
                    isChild={isChildRow}
                    label={chooseTag()}
                  />
                );
              default:
                return null;
            }
          })()}
        </CustomTableCell>
      ))}
    </TableRowContainer>
  );
};
